import React, { Suspense, useEffect, useState } from 'react'
import { Outlet } from 'react-router-dom'

import Header from 'components/Header/Header'
import Sidebar from 'components/Sidebar/Sidebar'
import Loader from 'components/Loader'

import { notificationsApi } from 'features/notifications/api/notificationsApi'
import { getFirebaseToken } from 'lib/firebase'
import { handleRequestError } from 'utils/handleRequestError'

const DefaultLayout = () => {
  const StoreNotificationToken = async (token) => {
    try {
      const response = await notificationsApi.storeFcmToken(token)
      if (response.data.success) {
        // eslint-disable-line no-empty
      }
    } catch (error) {
      handleRequestError(error)
    }
  }

  const handleGetFirebaseToken = () => {
    getFirebaseToken()
      .then((firebaseToken) => {
        StoreNotificationToken(firebaseToken)
      })
      .catch((err) =>
        console.error(
          'An error occured while retrieving firebase token. ',
          err,
        ),
      )
  }

  useEffect(() => {
    handleGetFirebaseToken()
  }, [])

  const [sidebarOpen, setSidebarOpen] = useState(false)

  return (
    <div className='dark:bg-boxdark-2 dark:text-bodydark'>
      <div className='flex h-screen overflow-hidden'>
        <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />

        <div
          data-scroll-container='admin-main'
          className='relative flex flex-col flex-1 overflow-x-hidden overflow-y-auto bg-gray/5'
        >
          <Header sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
          <main>
            <div className='p-5 mx-auto max-sm:p-4'>
              <Suspense fallback={<Loader />}>
                <Outlet />
              </Suspense>
            </div>
          </main>
        </div>
      </div>
    </div>
  )
}

export default DefaultLayout
